import _ from 'lodash';
import { SET } from './action-types';


export default function reducers(state = {}, action = { data: {} }) {
  switch (action.type) {
    case SET:
      _.assign(state, action.data);
      break;
    default:
      return state;
  }

  return { ...state };
}
